import { render } from "./UserPosts.vue?vue&type=template&id=4b1524f0&scoped=true"
import script from "./UserPosts.vue?vue&type=script&lang=js"
export * from "./UserPosts.vue?vue&type=script&lang=js"

import "./UserPosts.vue?vue&type=style&index=0&id=4b1524f0&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1524f0"]])

export default __exports__